// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.code[data-v-fd40ce16] {\n  margin: 0;\n  color: #409eff;\n  font-size: 14px;\n  word-wrap: break-word;\n  word-break: normal;\n}\n", ""]);
// Exports
module.exports = exports;
